import script from "./MaintenancePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MaintenancePage.vue?vue&type=script&lang=ts&setup=true"

import "./MaintenancePage.vue?vue&type=style&index=0&id=6685961a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6685961a"]])

export default __exports__